import React from "react";
import { Col, Row } from "reactstrap";

export default function ProfileSettingsIntro() {
  return (
    <>
      <Row>
        <Col md={2}></Col>
        <Col md={8}>
          <div
            style={{ height: "calc(80vh - 100px)" }}
            className={
              "d-flex flex-column justify-content-center align-items-center"
            }
          >
            <div>
              <h1 className={"p-2"}>Profile Settings</h1>
            </div>
            <div>
              <h6 className={"text-muted text-center"}>
                Your own account: your details, your password, your notification preferences. Nothing here affects anyone else.{" "}
                <button
                  type="button"
                  className="btn btn-link p-0 align-baseline"
                  onClick={() => window.Tawk_API?.toggle?.()}
                >
                  Click to Chat
                </button>
              </h6>
            </div>
          </div>
        </Col>
        <Col md={2}></Col>
      </Row>
    </>
  );
}
